module.exports = __webpack_public_path__ + "static/media/PFHandbookProMedium.cfec0550.woff";